<template>
  <app-chart-wrapper>
    <div class="header">
      <h5 class="header-title">
        {{$t('message.statistics.message.heatMap')}}
        <i class="mdi mdi-help-circle-outline pointer"
           v-tooltip="{content: this.$t('message.statistics.message.tooltipHeatMap')}"></i>
      </h5>

      <div class="header-density">
        <p class="header-density-label">{{$t('message.statistics.message.density')}}: </p>
        <vue-slider class="header-density-slider"
                    v-model="density"
                    :width="200"
                    :max="maxDensity"></vue-slider>
      </div>

    </div>

    <div class="statistics-heat-map-body">
      <loading v-if="loading" />

      <div v-else
           class="statistics-heat-map-body-grid">
        <div class="statistics-heat-map-body-grid-density">
          <div v-for="(item, index) in densitySizeRanges"
               :key="index"
               class="statistics-heat-map-body-grid-density-item">
            <div class="statistics-heat-map-body-grid-density-item-color"
                 :style="`background: ${getColor(index)}`"></div>
            <div class="statistics-heat-map-body-grid-density-item-text">
                {{$t('message.statistics.message.from')}} {{ item.start }} {{$t('message.statistics.message.to')}} {{ item.end }}
            </div>
          </div>

          <div class="statistics-heat-map-body-grid-density-item">
            <div class="statistics-heat-map-body-grid-density-item-color"></div>
            <div class="statistics-heat-map-body-grid-density-item-text">
                {{$t('message.statistics.message.above')}} {{density}}
            </div>
          </div>
        </div>

        <div class="statistics-heat-map-body-grid-body">
          <statistics-heat-map-row v-for="(item, index) in items"
                                   :key="index"
                                   :item="item"
                                   :isLastRow="index === (items.length - 1)"
                                   :ranges="densitySizeRanges" />
        </div>

        <div class="statistics-heat-map-body-grid-bottom">
          <div class="statistics-heat-map-body-grid-bottom-div"></div>

          <div class="statistics-heat-map-body-grid-bottom-list">
            <div class="statistics-heat-map-body-grid-bottom-list-items"
                 :style="`grid-template-columns: repeat(${hoursLength}, 40px);`">
              <div v-for="(hourItem, index) in hoursClock"
                   :key="index"
                   class="statistics-heat-map-body-grid-bottom-items-hour">{{ hourItem }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </app-chart-wrapper>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import StatisticsHeatMapRow from "@/components/modules/statistics/heat/map/row/StatisticsHeatMapRow";
import Loading from "@/components/generic/Loading.vue";
import AppChartWrapper from "@/components/chart/ChartWrapper";

export default {
  components: {
    AppChartWrapper,
    Loading,
    StatisticsHeatMapRow,
    VueSlider,
  },

  data() {
    return {
      maxDensity: 300,
      density: 150,
      separationSize: 10,
      value: 0,
    };
  },

  mounted() {},

  props: {
    loading: {
      type: Boolean,
    },
  },

  computed: {
    hoursClock() {
      return this.items[0]
        ? Object.keys(this.items[0].hour).map((hour) => {
            return `${hour < 10 ? "0" : ""}${hour}:00`;
          })
        : [];
    },
    hoursLength() {
      return this.items[0] ? Object.keys(this.items[0].hour).length : 0;
    },
    densityRange() {
      return this.density / this.separationSize;
    },
    densitySizeRanges() {
      const array = Array.apply(null, Array(this.separationSize));

      return array.map((_, index) => {
        return {
          start: Math.floor(index == 0 ? 0 : this.densityRange * index + 1),
          end: Math.floor(this.densityRange * (index + 1)),
        };
      });
    },
    heatMapData() {
      return this.$store.state.statistics.heatMap;
    },
    items() {
      const localIds = this.heatMapData ? Object.keys(this.heatMapData) : [];

      const localArrays = localIds.map((localId) => {
        return this.heatMapData[localId];
      });

      return localArrays;
    },
  },

  watch: {
    heatMapData() {
      this.setDensity();
    },
  },

  methods: {
    setDensity() {
      let maxDensity = 0;

      if (this.heatMapData) {
        const localKeys = Object.keys(this.heatMapData);

        localKeys.forEach((localKey) => {
          const localHourArray = this.heatMapData[localKey].hour;

          const localHourValues = Object.values(localHourArray);

          const localMax = Math.max(...localHourValues);

          if (localMax > maxDensity) {
            maxDensity = localMax;
          }
        });

        this.maxDensity = maxDensity;
        this.density = Math.floor(maxDensity / 2);
      }
    },
    getColor(index) {
      return {
        0: "rgba(31, 122, 31, 0.5)",
        1: "rgba(31, 122, 31, 0.65)",
        2: "rgba(31, 122, 31, 0.85)",
        3: "rgba(31, 122, 31, 1)",
        4: "rgba(230, 230, 0, 0.5)",
        5: "rgba(230, 230, 0, 0.75)",
        6: "rgba(230, 230, 0, 0.85)",
        7: "rgba(230, 230, 0, 1)",
        8: "rgba(255, 64, 0, 0.65)",
        9: "rgba(255, 64, 0, .8)",
      }[index];
    },
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  .header-title {
    margin: 0;
  }

  .header-density {
    display: flex;
    align-items: center;
    gap: 20px;

    .header-density-label {
      margin: 0;
      font-size: 14px;
    }
  }
}

.statistics-heat-map-body {
  .loading {
    margin: 0 auto;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    top: 50%;
    transform: translateY(-50%);
  }

  .statistics-heat-map-body-grid {
    .statistics-heat-map-body-grid-density {
      display: flex;
      justify-content: center;
      gap: 10px;
      margin-bottom: 20px;
      flex-wrap: wrap;

      .statistics-heat-map-body-grid-density-item {
        display: flex;
        font-size: 13px;
        align-items: center;
        gap: 5px;
        flex-shrink: 0;

        .statistics-heat-map-body-grid-density-item-color {
          width: 10px;
          height: 10px;
          background: red;
          border-radius: 50%;
        }
      }
    }

    .statistics-heat-map-body-grid-body {
      padding-right: 15px;
      max-height: 400px;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }

  .statistics-heat-map-body-grid-bottom {
    grid-template-columns: 120px 1fr;
    display: grid;

    .statistics-heat-map-body-grid-bottom-list {
      .statistics-heat-map-body-grid-bottom-list-items {
        display: grid;
        justify-content: space-between;

        .statistics-heat-map-body-grid-bottom-items-hour {
          font-size: 12px;
          margin-top: 10px;
          transform: rotate(-15deg);
        }
      }
    }
  }
}
</style>
